import React from 'react'
import { getTranslations, ITranslations } from '../../../../../services/translations'
import { useConfigContext } from '../../../../App/App'

interface IProps {
  fromDate: Date
  toDate: Date
}

const DateTime = ({ fromDate, toDate }: IProps) => {
  const { langCode } = useConfigContext()
  const translations: ITranslations = getTranslations(langCode)

  const renderMain = (): string => {
    if (showDate(fromDate)) {
      return renderDate(fromDate)
    } else if (isToday(fromDate) && isFullDayEvent(fromDate, toDate)) {
      return translations.today
    } else {
      return renderTime(fromDate)
    }
  }

  const renderSub = (): string => {
    if (showDate(fromDate)) {
      if (isSameDay(fromDate, toDate)) {
        return renderTime(fromDate, toDate, `${translations.dateAt} `)
      } else {
        return `${translations.dateTo} ${renderDate(toDate)}`
      }
    } else if (showDate(toDate)) {
      return `${translations.dateTo} ${renderDate(toDate)}`
    } else {
      return renderTime(toDate, fromDate, `${translations.dateTo} `)
    }
  }

  const renderDate = (date: Date): string => {
    if (isTomorrow(date)) {
      return translations.tomorrow
    } else if (isToday(date)) {
      return translations.today
    } else {
      return `${date.getDate()}. ${date.getMonth() + 1}.`
    }
  }

  const renderTime = (dateMain: Date, dateSub?: Date, prepend: string = ''): string => {
    if (dateSub && isFullDayEvent(dateMain, dateSub)) {
      return translations.allDay
    }

    return `${prepend}${dateMain.getHours()}:${dateMain.getMinutes() < 10
      ? `0${dateMain.getMinutes()}`
      : dateMain.getMinutes()}`
  }

  const showDate = (date: Date): boolean => {
    const tomorrow = new Date()
    tomorrow.setFullYear(tomorrow.getFullYear(), tomorrow.getMonth(), tomorrow.getDate() + 1)
    tomorrow.setHours(0, 0, 0, 0)

    return date.getTime() >= tomorrow.getTime()
  }

  const isTomorrow = (date: Date): boolean => {
    const tomorrow = new Date()
    tomorrow.setFullYear(tomorrow.getFullYear(), tomorrow.getMonth(), tomorrow.getDate() + 1)
    tomorrow.setHours(0, 0, 0, 0)

    const eventDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0,
      0,
      0,
      0,
    )

    return eventDate.getTime() === tomorrow.getTime()
  }

  const isToday = (date: Date): boolean => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    const eventDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0,
      0,
      0,
      0,
    )

    return eventDate.getTime() === today.getTime()
  }

  const isSameDay = (date1: Date, date2: Date): boolean => {
    return date1.getDate() === date2.getDate()
      && Math.abs(date1.getTime() - date2.getTime()) / 3600000 <= 24
  }

  const isFullDayEvent = (date1: Date, date2: Date): boolean => {
    const oneDayInMs = 86400000

    return isSameDay(date1, date2) && (
      (date2.getTime() > date1.getTime() && (((date2.getTime() - date1.getTime()) + 60000) / oneDayInMs) === 1) ||
      (date1.getTime() > date2.getTime() && (((date1.getTime() - date2.getTime()) + 60000) / oneDayInMs) === 1)
    )
  }

  return (
    <div className="time">
      <div className="main">
        {renderMain()}
      </div>
      <div className="sub">
        {renderSub()}
      </div>
    </div>
  )
}

export default DateTime
